import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message, Upload, Icon} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, toImportExcel, downLoadTemplate} from 'Utils';
import {objectSerial, config} from 'Utils';
import {getOrderList, deleteList, getSubStoreList} from '../../service/thingsOrder';
import moment from 'moment';
import {Actions, Store} from "../order/store";

class CustomeOrderList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.store = Reflux.initStore(Store);
        this.state = {
            opts: ['订单管理'],
            key: 0,
            selectedRowKeys: [],
            selectedRows: [],
            rows: [],
            total: 1,
            totalAmount: 0,
            subStoreList: [],
            searchObj: {
                code: props.location.query.code || '', // 编号
                orderStatus: '', // 状态
                productCode: '', // 物料编号
                cusName: '', // 客户名称
                orderDateStart: '', // 起
                orderDateEnd: '', // 止
                remark: '',
                isCancel: false,
                // shipTime: {},	// 日期筛选
                s: 10,
                p: 1,
                orderType: '',
                storageId: ''
            },
            visible: false,
            button_limits_end: {},
            loading: true
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*下载模板*/
    downloadChange() {
        downLoadTemplate(10);
    }

    /*删除*/
    deleteFn() {
        const {selectedRows, selectedRowKeys} = this.state;
        // const flag = selectedRows.some(item => item.orderStatus === 0 || item.orderStatus === 1);
        if (selectedRowKeys.length == 0) {
            openNotice('warning', '请选择删除数据！', '');
            return false;
        }
        // 注释的判断逻辑已在tabelProps.rowSelection.getCheckboxProps中实现，并改进
        // if (flag) {
        //     openNotice('warning', '只能删除暂存和驳回的订单！', '');
        //     return false;
        // }
        this.setState({loading: true});
        deleteList(this.state.selectedRowKeys).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                this.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
                this.setState({loading: false});
            }
        });
    }

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderDateStart: value.from,
                    orderDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                code: '', // 编号
                orderStatus: '', // 状态
                productCode: '', // 物料编号
                cusName: '', // 客户名称
                orderDateStart: '', // 起
                orderDateEnd: '', // 止
                remark: '',
                storageId: '',
                isCancel: false,
                p: 0,
                s: 10,
            }, loading: true
        }, () => {
            self.initData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        var sObj = this.state.searchObj;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        getOrderList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total || 0,
                    totalAmount: result.data.length > 0 ? result.data[0].totalReceivedAmount : 0,
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                })
                message.error(result.message);
            }
        });
        getSubStoreList({
            removeFlag: 0,
            s: 10000,
            p: 1,
        }).then((result) => { //获取子库存
            if (result && result.code == 200) {
                result.data.map((item, key) => {
                    item.value = item.id;
                    item.text = item.subStoreName;
                })
                this.setState({subStoreList: result.data});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
    }

    /*删除*/
    deleteRecord(index) {
        // console.log('delet' + index);
        let params = {
            'ids': index
        };
        let self = this;
        this.setState({loading: true});
        deleteList(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '删除成功', '');
                self.initData();
            } else {
                openNotice('error', '删除失败', (result && result.message) ? result.message : '');
                this.setState({loading: false});
            }
        });

    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeys, selectedRows});
        // console.log()
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'thingsOrder' || path[0] === 'thingsOrder') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        console.log(data);
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...data.storeData,
                }
            });
        }
    }

    edit(record) {
        this.goView(`/thingsOrder/edit/${record.id}`);
    }

    exportChange = () => {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/trans/order/exportList?${objectSerial(_searchObj)}`;
        window.open(url);
    }

    /*复制按钮*/
    addAgain(record) {
        //const { selectedRowKeys} = this.state;
        //const flag = selectedRows.some(item => item.orderStatus !== 0);
        /*if (selectedRowKeys.length == 0) {
            openNotice('warning', '请选择需要复制的订单！', '');
            return false;
        }*/
        this.goView(`/thingsOrder/addCopy/${record.id}`);
        //console.log(this.state.selectedRowKeys);
    }


    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        var self = this;
        const {
            opts,
            key,
            rows,
            total,
            selectedRowKeys,
            searchObj,
            visible,
            button_limits_end,
            loading,
            totalAmount,
            subStoreList
        } = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'code',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.code
                },
                {
                    name: 'orderStatus',
                    label: '状态',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '0', text: '未登记'},
                        {value: '1', text: '已登记'},
                        {value: '4', text: '已完成'},
                        {value: '5', text: '已冲销'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.orderStatus
                },
                {
                    name: 'orderType',
                    label: '订单类型',
                    text: '选择订单类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '1', text: '销售单'},
                        {value: '2', text: '零售单'},
                        {value: '3', text: '退货单'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.orderType
                },
                {
                    name: 'storageId',
                    label: '子库存',
                    text: '选择订单类型',
                    options: subStoreList,
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.storageId
                },
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusName
                },
                {
                    name: 'productCode',
                    label: '物料编码/描述',
                    text: '输入物料编码/描述',
                    type: 'default',
                    defaultValue: searchObj.productCode
                },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '订单日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderDateStart || '',
                        end: searchObj.orderDateEnd || ''
                    }
                }, {
                    name: 'isCancel',
                    label: '显示冲销状态',
                    text: '显示冲销状态',
                    defaultValue: searchObj.isCancel,
                    type: 'SwitchInput',
                    labelStyle: {width: "300px"}
                }, {
                    name: 'remark',
                    label: '备注',
                    text: '输入备注',
                    type: 'default',
                    defaultValue: searchObj.remark
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        if (this.userData.second) {
            advanceProps.fileds.splice(4, 1);
        }
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '订单编号',
                    dataIndex: 'code',
                    render: (text, record, index) => {
                        return <a href={`#/thingsOrder/${record.id}`}>{text}</a>
                    }
                }, {
                    title: '客户名称',
                    dataIndex: 'cusName'
                }, {
                    title: '客户简称',
                    dataIndex: 'cusShortname'
                },
                {
                    title: '订单类型',
                    dataIndex: 'orderType',
                    width: '75px',
                    render: (text, record, index) => {
                        if (text === 1) return '销售单';
                        if (text === 2) return '零售单';
                        if (text === 3) return '退货单';
                        return '';
                    }
                },
                {
                    title: '下单时间',
                    dataIndex: 'orderDate',
                    render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                },
                {
                    title: '销售金额',
                    dataIndex: 'receivedAmount',
                    width: '85px',
                    render: (text, record, index) => {
                        return (record.orderType == 3 ? -text : text);
                    }
                },
                {
                    title: '整单折扣(%)',
                    dataIndex: 'discountRate'
                },
                {
                    title: '实收金额',
                    dataIndex: 'AmountCollected',
                    width: '85px',
                    render: (text, record, index) => {
                        if (record.discountRate > 0) {
                            var amount = Math.round(record.receivedAmount * record.discountRate) / 100;
                            return (record.orderType == 3 ? -amount.toFixed(2) : amount.toFixed(2));
                        } else {
                            return (record.orderType == 3 ? -record.receivedAmount : record.receivedAmount);
                        }
                    }
                },
                {
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    width: '75px',
                    render: (text, record, index) => {
                        if (text === -1) return '暂存';
                        if (text === 0) return self.userData.second ? '已提交' : '未登记';
                        if (text === 1) return '已登记';
                        if (text === 2) return '驳回';
                        // if (text === 3) return '待收货';
                        if (text === 4) return '已完成';
                        if (text === 5) return '已冲销';
                        // if (text === 6) return '暂存';
                        // if (text === 7) return '已审核';
                        return '';
                    }
                }, {
                    title: '子库存',
                    dataIndex: 'storageName'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '操作员',
                    dataIndex: 'operateName'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    render: (text, record, index) => {
                        if (self.userData.second) {
                            return <div>
                                {button_limits_end.thingsOrder_list_05 &&
                                    <Button size={'small'} type="danger"
                                            onClick={this.addAgain.bind(self, record)}>复制</Button>}
                                {button_limits_end.thingsOrder_list_05 && (record.orderStatus == -1 || record.orderStatus == 2) &&
                                    <Button size={'small'} style={{marginLeft: '10px'}}
                                            onClick={self.edit.bind(self, record)}>编辑</Button>}
                            </div>;
                        } else {
                            return <div>
                                {button_limits_end.thingsOrder_list_05 && (record.orderStatus == 0 || record.orderStatus == 1 || record.orderStatus == 4) &&
                                    <Button size={'small'} type="danger"
                                            onClick={this.addAgain.bind(self, record)}>复制</Button>}
                                {button_limits_end.thingsOrder_list_05 && record.orderStatus == 0 &&
                                    <Button size={'small'} style={{marginLeft: '10px'}}
                                            onClick={self.edit.bind(self, record)}>编辑</Button>}
                            </div>;
                        }
                    }
                }
            ],
            rows,
            // this.userData.second
            rowSelection: {
                selectedRowKeys,
                getCheckboxProps: (record) => {
                    /***
                     * 2020-02-21 13:30:00 添加这部分代码
                     * 2020年DMC升级上线反馈2.0.docx 文件中要求的控制逻辑
                     * 1    一级客户主账号、一级客户子账户的删除权限：
                     * 1.1    只能删除‘一级客户创建的订单’，状态为‘未登记’
                     * 1.2    不允许删除状态为‘已登记’的订单，系统提示：不允许删除已登记的订单
                     * 1.3    不允许删除‘二级客户创建的订单’，系统提示：不允许删除二级客户的订单
                     *
                     * 2    二级客户账号的删除权限：
                     * 2.1    只能删除‘二级客户创建的订单’，状态为‘暂存’和‘驳回’
                     * 2.2    不允许删除状态为‘已登记’的订单，系统提示：不允许删除已登记的订单
                     * 2.3    不允许删除状态为‘已提交’的订单，系统提示：不允许删除已提交的订单
                     *
                     * second false：一级 true:二级
                     * createFlag： 1（一级创建的订单） 2（二级创建的订单）
                     * orderStatus  -1暂存 0未登记 1已登记 2驳回
                     */
                    if (self.userData.second == false) {
                        //判断订单是否是二级的
                        if (record.createFlag == 2) {
                            // print("不允许删除二级客户的订单")
                            return {disabled: true};
                        } else {
                            //判断订单状态
                            //去掉已取消删除权限
                            if (record.orderStatus == 1 || record.orderStatus == 4 || record.orderStatus == 5) {
                                // print("不允许删除已登记的订单")
                                return {disabled: true};
                            }
                        }
                    } else {
                        if (record.createFlag == 1) {
                            // print("不允许删除一级客户创建的订单")
                            return {disabled: true};
                        } else {
                            //判断订单状态
                            if (record.orderStatus == 1 || record.orderStatus == 4 || record.orderStatus == 5) {
                                // print("不允许删除已登记的订单")
                                return {disabled: true};
                            } else if (record.orderStatus == 0) {
                                // print("不允许删除已提交的订单")
                                return {disabled: true};
                            }
                        }
                    }
                    return false;
                },
                onChange: this.onSelectChange
            }
        };
        let uploadParam = toImportExcel(10, () => {
            this.initData();
        });
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <span style={{
                        position: 'absolute',
                        bottom: 8,
                        right: 0
                    }}>&emsp;共{total}个订单 &nbsp;合计金额{totalAmount}元</span>
                    {button_limits_end.thingsOrder_list_01 &&
                        <Button icon="plus" onClick={this.goView.bind(this, '/thingsOrder/add')}
                                style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>}
                    {button_limits_end.thingsOrder_list_01 &&
                        <Button icon="minus" onClick={this.deleteFn.bind(this)}
                                style={{position: 'absolute', bottom: 8, left: 88}}>删除</Button>}
                    <Button style={{position: 'absolute', bottom: 8, left: 176}} icon="export"
                            onClick={this.exportChange.bind(this)}>导出</Button>
                    {button_limits_end.thingsOrder_list_06 && <Upload {...uploadParam}>
                        <Button style={{position: 'absolute', bottom: 8, left: 264}}>
                            <Icon type="upload"/>导入
                        </Button>
                    </Upload>}
                    {button_limits_end.thingsOrder_list_07 &&
                        <Button icon="download" style={{position: 'absolute', bottom: 8, left: 353}}
                                onClick={this.downloadChange}>下载模板</Button>}
                </div>
                <TableView {...tableViewProps} />
            </div>

            <Modal
                visible={visible}
                title="入库"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={800}
            >
                <div>
                    <Row>
                        <Col>
                            <label className="ant-form-item-required">是否增加库存：</label>
                            <Radio.Group onChange={self.onChange} value={this.state.value}>
                                <Radio value={'Y'}>是</Radio>
                                <Radio value={'N'}>否</Radio>
                            </Radio.Group>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label>子库存：</label>
                            <Select defaultValue="jack" style={{width: 120}} onChange={self.handleChange}>
                                <Select.Option value="jack">电力01库</Select.Option>
                                <Select.Option value="lucy">电力02库</Select.Option>
                            </Select>
                        </Col>
                    </Row>
                    <Row style={{marginTop: 10}}>
                        <Col>
                            <label className="ant-form-item-required">验证码：</label>
                            <Input style={{width: 65}} maxLength='6'/>
                            <Button style={{marginLeft: 10}}>获取验证码</Button>
                            <span style={{
                                fontSize: 'xx-small',
                                display: 'none'
                            }}>已向授权收货人手机：13888888888发送短信</span>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    }
}
;
export default withRouter(CustomeOrderList);



// WEBPACK FOOTER //
// ./src/routes/thingsOrder/list.js